import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import { IState, ISuccessAction, IFailureAction } from 'interfaces/create-duck';

const { Types, Creators } = createActions(
  {
    request: ['postData', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['error'],
    reset: [],
  },
  { prefix: 'CREATE_CARRIER_AREA_CONTACT_' }
);

export interface CreateCarrierAreaContactState extends IState {}

const INITIAL_STATE: CreateCarrierAreaContactState = {
  loading: false,
  error: null,
};

const request = (state: CreateCarrierAreaContactState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: CreateCarrierAreaContactState,
  action: ISuccessAction
) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (
  state: CreateCarrierAreaContactState,
  action: IFailureAction
) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const createCarrierAreaContact = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const CreateCarrierAreaContactTypes = Types;
export const CreateCarrierAreaContactActions = Creators;
